import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/index';
import Login from './pages/Login';
import VerificationStepOne from './pages/VerificationStepOne';
import LoginSuccess from './pages/LoginSuccess';
import SignUp from './pages/signUp';
import SignUpSuccess from './pages/signUp/SignUpSuccess';
import Legal from './pages/Legal';
import ForgotPassword from './pages/ForgotPassword';
import InviteMember from './pages/InviteMember';
import InviteMemberForm from './pages/InviteMemberForm';
import InviteLandingPage from './pages/InviteLandingPage';
import RedeemDriverInvite from './pages/RedeemDriverInvite';
import { environments } from './constants';
import mixpanelService from './services/mixpanel';

const AppRoutes = () => {
  useEffect(() => {
    mixpanelService.track('Routes', {
      driverInvitePath: environments.REACT_APP_ORG_V2_INVITE_REDEEM_DRIVER || '',
    });
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/verification-step-one" element={<VerificationStepOne />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/login/:serviceURL/:clientId" element={<Login />} />
      <Route path="/invite/:email/:inviteId" element={<InviteMember />} />
      <Route path="/invite/sso/sign-up" element={<InviteMemberForm />} />
      <Route path="/login-redirect/:serviceURL/:token" element={<LoginSuccess />} />
      <Route path="/signup/:serviceURL" element={<SignUp />} />
      <Route path="/signup-redirect/:serviceURL/:token" element={<SignUpSuccess />} />
      <Route path="/legal/:legalDocument" element={<Legal />} />
      <Route path="/invite/driver" element={<InviteLandingPage />} />
      <Route path="/redeem/driver/invite" element={<RedeemDriverInvite />} />
    </Routes>
  );
};

export default AppRoutes;
